import React from 'react'
import MainNav from '../../Components/Navbar'

function Professores() {
    return (
        <>
            <MainNav />
            <div>Professores</div>
        </>
    )
}

export default Professores